import Repository from "../Repository";

const resource = "/me";

export default {
  login(email, password) {
    const data = {
      email: email,
      password: password
    };

    return Repository.post(`${resource}/login`, data);
  }
};
